module.exports = __webpack_public_path__ + "gs.5be3b10695f909a19de8.jpg";